import { getTelLinkFromPhone } from "./utils/getTelLinkFromPhone";
import { parseWhatsappContactsString } from "./utils/storeWhatsappContacts";

export function getContact(component) {
  const contact = [];

  if (component.informations.address)
    contact.push({
      text: component.informations.address,
      link: component.informations.google_maps
        ? component.informations.google_maps
        : "",
      target: "_blank",
      icon: "fas fa-map-marker-alt",
    });
  if (component.informations.tel)
    contact.push({
      text: component.informations.tel,
      link: getTelLinkFromPhone(component.informations.tel),
      target: "_self",
      icon: "fas fa-phone-alt",
    });
  if (component.informations.whatsapp) {
    for (const { label, whatsappLink } of parseWhatsappContactsString(
      component.informations.whatsapp
    )) {
      contact.push({
        text: label,
        link: whatsappLink,
        target: "_blank",
        icon: "fab fa-whatsapp",
      });
    }
  }
  if (component.informations.email)
    contact.push({
      text: component.informations.email,
      link: "mailto:" + component.informations.email,
      target: "_self",
      icon: "fas fa-envelope",
    });

  return contact;
}
export function getSocial(component) {
  const social = [];
  if (component.social.facebook)
    social.push({
      link: component.social.facebook,
      target: "_blank",
      icon: "fab fa-facebook",
    });
  if (component.social.instagram)
    social.push({
      link: component.social.instagram,
      target: "_blank",
      icon: "fab fa-instagram",
    });
  if (component.social.twitter)
    social.push({
      link: component.social.twitter,
      target: "_blank",
      icon: "fab fa-twitter",
    });
  if (component.social.youtube)
    social.push({
      link: component.social.youtube,
      target: "_blank",
      icon: "fab fa-youtube",
    });
  if (component.social.linkedin)
    social.push({
      link: component.social.linkedin,
      target: "_blank",
      icon: "fab fa-linkedin",
    });

  return social;
}
